/*!
 * Color mode toggler for Bootstrap's docs (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Licensed under the Creative Commons Attribution 3.0 Unported License.
 */

import * as params from '@params'
import { getLocalStorage, setLocalStorage } from './_cookie.js'

// The color-mode toggler ships in the critical bundle unconditionally; the site-level
// enablement (main.enableDarkMode / main.colorMode.enabled) is evaluated at runtime
// through build params instead of a build-time template conditional.
if (params.darkMode) {
  const supportedThemes = ['auto', 'dark', 'light']

  // retrieves the currently stored theme from local storage
  const storedTheme = getLocalStorage('theme', 'auto', 'functional')

  // retrieves the theme preferred by the client, defaults to light
  function getPreferredTheme () {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }

  // retrieves the current theme, either from local storage or client's preferences
  function getTheme () {
    if (storedTheme) {
      return storedTheme
    } else {
      const preference = getPreferredTheme()
      setLocalStorage('theme', preference, 'functional')
      return preference
    }
  }

  // applies and stores requested theme
  function setTheme (theme) {
    if (!supportedThemes.includes(theme)) {
      theme = 'auto'
    }
    setLocalStorage('theme', theme, 'functional')

    if (theme === 'auto') {
      theme = getPreferredTheme()
    }
    document.documentElement.setAttribute('data-bs-theme', theme)
    // store main theme separately, to avoid the navbar mode icon uses a local variable
    document.documentElement.setAttribute('data-bs-main-theme', theme)

    updateSelectors()
  }

  // alternates the currently active theme
  function toggleTheme () {
    const target = document.documentElement.getAttribute('data-bs-theme') === 'dark' ? 'light' : 'dark'
    setTheme(target)
  }

  function updateSelectors () {
    document.querySelectorAll('.navbar-mode-selector').forEach(chk => {
      chk.checked = (document.documentElement.getAttribute('data-bs-theme') === 'light')
    })
  }

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (storedTheme !== 'light' || storedTheme !== 'dark') {
      setTheme(getPreferredTheme())
    }
  })

  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.navbar-mode-selector').forEach(chk => {
      chk.addEventListener('change', function () {
        document.documentElement.setAttribute('data-bs-theme-animate', 'true')
        toggleTheme()
      })
    })
  })

  window.addEventListener('load', () => {
    // update the selectors when all elements are ready
    updateSelectors()
  })

  // initialize theme as soon as possible to reduce screen flickering
  setTheme(getTheme())
}
